import { decode as atob } from "base-64";

export function dec(str) {
  let buf = atob(str);
  let ary_buf = new ArrayBuffer(buf.length);
  let dv = new DataView(ary_buf);
  for (let i = 0; i < buf.length; i++) dv.setUint8(i, buf.charCodeAt(i));
  let f32_ary = new Float32Array(ary_buf);
  return f32_ary;
}

export function dataURLtoFile(dataurl, filename) {
  var arr = dataurl.split(","),
    mime = arr[0].match(/:(.*?);/)[1],
    bstr = atob(arr[1]),
    n = bstr.length,
    u8arr = new Uint8Array(n);

  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }

  return new File([u8arr], filename, { type: mime });
}

function getColor(cv, id) {
  const col_list = [
    new cv.Scalar(0, 176, 214, 255),
    new cv.Scalar(214, 98, 0, 255),
    new cv.Scalar(115, 94, 255, 255),
    new cv.Scalar(1, 243, 97, 255),
    new cv.Scalar(154, 21, 210, 255),
    new cv.Scalar(154, 250, 107, 255),
    new cv.Scalar(255, 71, 245, 255),
    new cv.Scalar(81, 174, 0, 255),
    new cv.Scalar(58, 113, 255, 255),
    new cv.Scalar(255, 218, 60, 255),
    new cv.Scalar(44, 24, 138, 255),
    new cv.Scalar(123, 252, 147, 255),
    new cv.Scalar(91, 0, 112, 255),
    new cv.Scalar(0, 237, 162, 255),
    new cv.Scalar(145, 0, 126, 255),
  ];
  return col_list[id % col_list.length];
}

function createResizedPoint(
  cv,
  pts,
  height,
  width,
  naturalHeight,
  naturalWidth
) {
  const x = (pts[0] * height) / naturalHeight;
  const y = (pts[1] * width) / naturalWidth;
  return new cv.Point(x, y);
}

export function drawBox(
  cv,
  image,
  height,
  width,
  naturalHeight,
  naturalWidth,
  data,
  labels,
) {
  var box_count = 0;
  for (var idx = 0; idx < data.length; idx++) {
    if (idx % 6 === 0) {
      var resized_pts_lu = createResizedPoint(
        cv,
        [data[idx], data[idx + 1]],
        height,
        width,
        naturalHeight,
        naturalWidth
      );
      var resized_pts_ru = createResizedPoint(
        cv,
        [data[idx + 2], data[idx + 1]],
        height,
        width,
        naturalHeight,
        naturalWidth
      );
      var resized_pts_rd = createResizedPoint(
        cv,
        [data[idx + 2], data[idx + 3]],
        height,
        width,
        naturalHeight,
        naturalWidth
      );
      var resized_pts_ld = createResizedPoint(
        cv,
        [data[idx], data[idx + 3]],
        height,
        width,
        naturalHeight,
        naturalWidth
      );
      var resized_pts_label = createResizedPoint(
        cv,
        [
          data[idx] < 5 ? 5 : data[idx],
          data[idx + 1] < 20 ? data[idx + 1] + 15 : data[idx + 1] - 5,
        ],
        height,
        width,
        naturalHeight,
        naturalWidth
      );

      cv.line(
        image, // image
        resized_pts_lu,
        resized_pts_ld,
        getColor(cv, box_count), // color
        2 // thickness
      );
      cv.line(
        image, // image
        resized_pts_lu,
        resized_pts_ru,
        getColor(cv, box_count), // color
        2 // thickness
      );
      cv.line(
        image, // image
        resized_pts_ru,
        resized_pts_rd,
        getColor(cv, box_count), // color
        2 // thickness
      );
      cv.line(
        image, // image
        resized_pts_ld,
        resized_pts_rd,
        getColor(cv, box_count), // color
        2 // thickness
      );

      cv.putText(
        image, // image
        labels[box_count], // text
        resized_pts_label, // org point (left top)
        cv.FONT_HERSHEY_PLAIN, // font face
        1, // font scale
        getColor(cv, box_count), // font color
        1, // thinkness
        cv.LINE_AA, // line type
        false // bottom left origin
      );

      box_count += 1;
    }
  }
}

export function drawTextline(
  cv,
  image,
  height,
  width,
  naturalHeight,
  naturalWidth,
  data
) {
  if (
    !data.hasOwnProperty("annotation") ||
    !data["annotation"].hasOwnProperty("blocks")
  ) {
    return;
  }
  const white = new cv.Scalar(255, 255, 255, 255);
  const black = new cv.Scalar(0, 0, 0, 255);

  const paragraphs = [];
  var color_id = -1;

  for (const block of data["annotation"]["blocks"]) {
    for (const paragraph of block["paragraphs"]) {
      paragraphs.push(paragraph);
      color_id += 1;
      for (const line of paragraph["lines"]) {
        for (const word of line["words"]) {
          var pts = [];
          for (const vertex of word["location"]["vertices"]) {
            pts.push([vertex.x, vertex.y]);
          }
          const resized_pts = pts.map((x) =>
            createResizedPoint(
              cv,
              x,
              height,
              width,
              naturalHeight,
              naturalWidth
            )
          );

          // Draw underline for word (All words in a pargraph have the same color)
          cv.line(
            image, // image
            resized_pts[2], // point 1 (left bottom)
            resized_pts[3], // point 2 (right bottom)
            getColor(cv, color_id), // color
            1 // thickness
          );

          // Draw border for text
          cv.putText(
            image, // image
            word.data, // text
            resized_pts[0], // org point (left top)
            cv.FONT_HERSHEY_SIMPLEX, // font face
            0.35, // font scale
            white, // font color
            2, // thinkness
            cv.LINE_8, // line type
            false // bottom left origin
          );
          // Draw text
          cv.putText(
            image, // image
            word.data, // text
            resized_pts[0], // org point (left top)
            cv.FONT_HERSHEY_SIMPLEX, // font face
            0.35, // font sacle
            black, // font color
            1, // thinkness
            cv.LINE_8, // line type
            false // bottom left origin
          );
        }
      }
    }
  }
  return paragraphs;
}
